import { Box, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import colorData from '../../../json/color.json';

interface ImageWithTitleProps {
  imageUrl: string;
  title: string;
  linkTo: string;  
  contentsCount: number;
  date: string;
}

/**
 * 実績リンクとサムネイル
 * @param imageUrl string
 * @param title string
 * @param linkTo string
 * @param contentsCount number 
 * @param date string 
 * @returns 
 */
const ImageWithTitle: React.FC<ImageWithTitleProps> = ({ imageUrl, title, linkTo, contentsCount, date }) => {
  
  const width = (contentsCount === 2) ? '500px' : '300px';
  const boxStyle = {
    textAlign: 'center',
    height: {xs: '200px', sm:'300px'},
    pb: 5,
    '& img': {
      maxWidth: width,
      height: 'auto',
      cursor: 'pointer',
      textAlign: 'center',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      '&:hover': {
        boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.2)',
      },
      '&:active': {
        transform: 'translateY(4px)',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
      }
    }
  }
  const titleStyle = {
    pt:3,
    pb:0,
  }
  return (
    <Box sx={boxStyle}>
      <Link to={linkTo}>
        <img
          loading="lazy"
          decoding="async"
          src={imageUrl}
          alt={title}
          style={{ width: '100%', cursor: 'pointer' }}
        />
      </Link>
      <Typography sx={titleStyle}><Link to={linkTo} style={{textDecoration: 'none', color: colorData['black']}}>{date}：{title}</Link></Typography>
    </Box>
  );
};

export default ImageWithTitle;
